export const MARKETING_PLAN_COLUMNS = {
	name: "name",
	status: "color_mkq9abwz",
} as const;

export enum MARKETING_PLAN_STATUS {
	none = "",
	ToBeCategorized = "To be categorized",
	ToBeStarted = "To be started",
	Running = "Running",
	Complete = "Complete",
	Blocked = "Blocked",
	Paused = "Paused",
	Canceled = "Canceled",
}
